import styled from "@emotion/styled";

export const StyledModalHeader = styled("header")`
    display: flex;
    align-items: start;
    justify-content: space-between;
    flex: 0 0 auto;
    transition: box-shadow 200ms;
`;
